<template>
    <SearchObject
        class="mt-0"
        :additional-params="{ ordering: '-invoice_date', ...additionalParams }"
        :allow-create="allowCreate"
        :autofocus="autofocus"
        :base-url="baseUrl"
        :create-label="$translate('create_a_invoice')"
        :disabled="disabled"
        :hide-details="hideDetails"
        :item-text="itemText"
        :label="label || $translate('select_invoice')"
        :readonly="readonly"
        :required="required"
        :value="value"
        @create="createInvoice"
        @input="handleInput"
        @select="handleSelect"
        ref="search"
        :error-messages="errorMessages"
        :dense="dense"
        :flat="flat"
        :outlined="outlined"
        :background-color="backgroundColor"
        :icon="icon"
    >
        <template slot="item" slot-scope="{ item }">
            <div class="my-1" v-if="item.id=='new'">
                {{ item.name }}
            </div>
            <div class="my-1" v-else>
                <div class="text-body-2">
                    {{ $moment(item.invoice_date).format('DD/MM/YYYY') }} - {{ $utils.getInvoiceIdText(item) }}
                </div>
                <div v-if="item.total_amount_excl_vat" class="text-caption text--secondary">
                    {{ price(item.total_amount_excl_vat) }}
                </div>
            </div>
        </template>
    </SearchObject>
</template>

<script>
import CustomerInvoiceEdit from "@/modals/customerinvoice";
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    name: "SearchCustomerInvoice",
    props: {
        // The base URL to fetch items from.
        baseUrl: {
            type: String,
            default: "/api/customerinvoices/",
        },
        // Additional GET parameters to include in the API request.
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        // Whether the component is disabled.
        disabled: {
            type: Boolean,
            default: false,
        },
        // v-model binding (selected item ID).
        value: {
            type: [String, Number],
            default: null,
        },
        // Label for the autocomplete.
        label: {
            type: String,
            default: "",
        },
        // Optional limit per request.
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        allowCreate: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: null,
        },
        flat: {
            type: Boolean,
            default: false,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        backgroundColor: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        // Customer ID to filter invoices (required for create)
        customerId: {
            type: [String, Number],
            default: null,
        },
    },
    methods: {
        handleInput(item) {
            // Emit the ID instead of the full object
            this.$emit("input", item?.id || null);
        },
        handleSelect(item) {
            // Emit the full object for select event
            this.$emit("select", item);
        },
        itemText(item) {
            const date = this.$moment(item.invoice_date).format('DD/MM/YYYY');
            const invoiceId = this.$utils.getInvoiceIdText(item);
            const total = item.total_amount_excl_vat ? ` - ${this.price(item.total_amount_excl_vat)}` : '';
            return `${date} - ${invoiceId}${total}`;
        },
        focus() {
            this.$refs.search.focus();
        },
        async createInvoice() {
            if (!this.customerId) {
                this.$swal({
                    title: this.$translate("error"),
                    text: this.$translate("selectCustomerFirst"),
                    type: "error",
                });
                return;
            }
            const result = await this.showModal({
                component: CustomerInvoiceEdit,
                params: {
                    invoice: {
                        biller: this.current_entity_id,
                        billed: this.customerId,
                        status: "draft",
                    },
                },
            });
            if (result) {
                this.$emit("input", result.id);
                this.$refs.search.update();
            } else {
                this.$emit("input", null);
                this.$refs.search.reset();
            }
        },
    },
    i18n: {
        messages: {
            en: {
                select_invoice: "Select an invoice",
                create_a_invoice: "Create new invoice",
                selectCustomerFirst: "Please select a customer first",
            },
            fr: {
                select_invoice: "Sélectionner une facture",
                create_a_invoice: "Créer une nouvelle facture",
                selectCustomerFirst: "Veuillez d'abord sélectionner un client",
            },
        },
    },
};
</script>

